import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Collapse from '@material-ui/core/Collapse'
import Typography from '@material-ui/core/Typography'
import LineChart from './LineChart'
import StackedAreaChart from './StackedAreaChart'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetSelectedData } from '../selectors/selectedDataSelector'
import { makeGetData } from '../selectors/dataSelector'
import ObjectActions from '../redux/objectRedux'
import MapActions from '../redux/mapRedux'
import TimeSliderActions from '../redux/timeSliderRedux'
import arrayIsNotEmpty from '../utility/arrayIsNotEmpty'
import createDatetimeMinMax from '../utility/createDatetimeMinMax'
import riverIceDataTransform from '../utility/riverIceDataTransform'

import lookupRiverIceType from '../utility/lookupRiverIceType'
import { RED, YELLOW, BLUE } from '../config/colors'

const chartStyles = {
  scatter: {
    data: {
      strokeWidth: 3,
      stroke: 'gray',
      strokeOpacity: 0.4,
      fill: d => (d.type === 1 ? BLUE : d.type === 2 ? YELLOW : RED)
    }
  }
}

const chartLabels = {
  scatter: d =>
    `${lookupRiverIceType(d.type)}: ${d.value.toFixed().toLocaleString()}`
}

class RiverIceLineChartContainer extends PureComponent {
  handleMouseEnter = (event, data) => {}

  handleMouseLeave = (event, data) => {}

  handleZoomToObject = (event, data) => {}

  render () {
    const { datetime, uuidsHighlighted, data, loading } = this.props

    if (!arrayIsNotEmpty(data)) {
      return null
    }
    if (data.length < 2) {
      return null
    }
    if (loading) {
      return null
    }

    const { minDatetime, maxDatetime } = createDatetimeMinMax(datetime)
    const filteredData = riverIceDataTransform(data.filter(
      datum => datum.timestamp > minDatetime && datum.timestamp < maxDatetime
    ))
    const groupByFilters = [
      item => item.type === 'rough',
      item => item.type === 'smooth',
      item => item.type === 'open'
    ]
    
    return (
      <Collapse
        component='div'
        in={arrayIsNotEmpty(filteredData)}
        unmountOnExit
      >
        <div>
          <Typography>Visible extent ice classification</Typography>
        </div>
        <StackedAreaChart
          data={filteredData}
          x={value => new Date(value.timestamp)}
          y={value => value.value}
          groupByFilters={groupByFilters}
          verticalLineAcessor={() => new Date(datetime).getTime()}
          datetime={new Date(datetime).getTime()}
          uuidsHighlighted={uuidsHighlighted}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          handleZoomToObject={this.handleZoomToObject}
          chartLabels={chartLabels}
          chartStyles={chartStyles}
        />
      </Collapse>
    )
  }
}

const makeMapStateToProps = () => {
  const getDatetime = makeGetDatetime()
  const getSelectedData = makeGetSelectedData()
  const getData = makeGetData()

  const mapStateToProps = state => {
    return {
      data: getData(state, 'RiverIcePoint', getFeaturesFromGeoJson),
      datetime: getDatetime(state, 'RiverIce'),
      fetching: state.data.fetching,
      selectedData: getSelectedData(state, 'MopraWellsites-fill'),
      uuidsSelected: state.object.uuidsSelected,
      uuidsHighlighted: state.object.uuidsHighlighted
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      centerZoomDatetimeChanged: (center, zoom, datetime) => {
        dispatch(MapActions.centerZoomChanged(center, zoom))
        dispatch(TimeSliderActions.timeSliderValueUpdated(datetime))
      },
      uuidsHighlighted: uuids => dispatch(ObjectActions.uuidsHighlighted(uuids))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  RiverIceLineChartContainer
)



// WEBPACK FOOTER //
// ./src/charts/RiverIcePointLineChartContainer.js